import {TemplateSection, TemplateSectionType} from '@app/modules/shared/models';

export interface ITemplateSectionState {
  templateSections: TemplateSection[];
  templateSectionTypes: TemplateSectionType[];
  success: string;
  error: string;
}

export const initialTemplateSectionState: ITemplateSectionState = {
  templateSections: [],
  templateSectionTypes: [],
  success: '',
  error: ''
};
